import React from "react";

import Applet from "../../Applet";
import ProjectMilestoneSessionTable from "../../../../components/Session/ProjectMilestoneSessionTable";

class ProjectMilestoneSessionTableApplet extends Applet {

    render() {
        return <ProjectMilestoneSessionTable applet={this}
                                 pageSize={this.props.PageSize ? this.props.PageSize : this.state.PageSize}
                                 placement={this.state.Placement}
                                 columns={this.state.Columns}
                                 title="Session"
                                 enterpriseComponent={this.getEnterpriseComponent()}
                                 sort={this.state.Sort}
                                 menu={this.state.Menu}
                                 rowHeight={this.state.RowHeight}
                                 simpleSearch={this.state.SimpleSearch}
                               // enableSort={true}
                               // enableSearch={true}

        />;
    }

    state = {
        Name: "ProjectMilestoneSessionTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 48,
        PageSize: {
            "default": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "CreatedDatetime",
                },
                {
                    id: "NumberOfAuditActions",
                },
                {
                    id: "UserAgent",
                },
                {
                    id: "IPAddress",
                },
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "CreatedDatetime",
                width: 240,
                cellRenderer: "Local Datetime Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Creation Date",
            },
            {
                id: "NumberOfAuditActions",
                width: 140,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "# Of Audit Events",
            },
            {
                id: "UserAgent",
                width: 740,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "User Agent",
            },
            {
                id: "IPAddress",
                width: 240,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "IP Address",
            },
        ],
        Sort: [
        ],
    }
}

export default ProjectMilestoneSessionTableApplet;
